// src/router/router.js

import { createRouter, createWebHistory } from 'vue-router';
import OwnerAccount from '../components/OwnerAccount.vue';
import CompanyAccount from '../components/CompanyAccount.vue';
import UserAccount from '../components/UserAccount.vue';
import LoginPage from '../components/LoginPage.vue';
import Settings from '../components/Settings.vue';
import IntakeForms from '../components/IntakeForms.vue';
import VoiceMail from '../components/VoiceMail.vue';
import Forms from '../components/Forms.vue';
import store from '../store/store.js';

// Companies allowed to access the staff Forms dashboard during
// development. 1002 = PNWBB (no document library seeded yet),
// 1008 = A-Affordable (the only tenant with documents in Mongo).
const FORMS_ALLOWED_COMPANIES = new Set([1002, 1008]);

const routes = [
  {
    path: '/',
    name: 'LoginPage',
    component: LoginPage,
  },
  {
    path: '/owner-account',
    name: 'OwnerAccount',
    component: OwnerAccount,
    beforeEnter: (to, from, next) => {
      if (store.getters.userRole === 'Owner') {
        next();
      } else {
        next({ name: 'LoginPage' });
      }
    },
  },
  {
    path: '/company-account',
    name: 'CompanyAccount',
    component: CompanyAccount,
    beforeEnter: (to, from, next) => {
      if (store.getters.userRole === 'Owner' || store.getters.userRole === 'Administrator') {
        next();
      } else {
        next({ name: 'LoginPage' });
      }
    },
  },
  {
    path: '/user-account',
    name: 'UserAccount',
    component: UserAccount,
    beforeEnter: (to, from, next) => {
      if (store.getters.userRole) {
        next();
      } else {
        next({ name: 'LoginPage' });
      }
    },
  },
  {
    path: '/forms',
    name: 'Forms',
    component: Forms,
    beforeEnter: (to, from, next) => {
      const companyNumber = store.getters.getSelectedCompany?.companyNumber;
      if (store.getters.userRole && FORMS_ALLOWED_COMPANIES.has(companyNumber)) {
        next();
      } else {
        next({ name: 'LoginPage' });
      }
    },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    beforeEnter: (to, from, next) => {
      // Allow access to Owner, Administrator, and User roles
      if (store.getters.userRole === 'Owner' || store.getters.userRole === 'Administrator' || store.getters.userRole === 'User') {
        next();
      } else {
        next({ name: 'LoginPage' });
      }
    },
  },
  {
    path: '/voice-mail',
    name: 'VoiceMail',
    component: VoiceMail,
    beforeEnter: (to, from, next) => {
      if (store.getters.userRole === 'Owner' || store.getters.userRole === 'Administrator' || store.getters.userRole === 'User') {
        next();
      } else {
        next({ name: 'LoginPage' });
      }
    },
  },
  {
    path: '/intake-forms',
    name: 'IntakeForms',
    component: IntakeForms,
    beforeEnter: (to, from, next) => {
      if (store.getters.userRole === 'Owner' || store.getters.userRole === 'Administrator' || store.getters.userRole === 'User') {
        next();
      } else {
        next({ name: 'LoginPage' });
      }
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'LoginPage' },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
